import { IPlusPropsPN } from "./DocumentTableInterfaces";

export default function PlusProductNumbers({
  productNumbers,
  setPopupContent,
  setShowPopup,
  setPopupTitle,
}: IPlusPropsPN) {
  const handleShowPopup = (productNumbers: string[]) => {
    setPopupContent(productNumbers);
    setShowPopup(true);
  };
  return (
    <div>
      {productNumbers?.[0] || ""}
      {productNumbers && productNumbers?.length > 1 && (
        <span
          className="plus"
          onClick={() => {
            handleShowPopup(productNumbers);
            setPopupTitle("Product Numbers");
          }}
        >
          {"+"}
          {productNumbers?.length - 1}
        </span>
      )}
    </div>
  );
}
